import { render, staticRenderFns } from "./JumboContainer.vue?vue&type=template&id=7ebecefa&scoped=true&"
import script from "./JumboContainer.vue?vue&type=script&lang=js&"
export * from "./JumboContainer.vue?vue&type=script&lang=js&"
import style0 from "./JumboContainer.vue?vue&type=style&index=0&id=7ebecefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebecefa",
  null
  
)

export default component.exports